import React from 'react';
import { Shield, Heart, Lock } from 'lucide-react';
import HeadingDots from './HeadingDots';

const items = [
  {
    icon: Heart,
    title: 'Designed for children',
    body: 'Spiick was built from the ground up for kids. Every interaction is guided to ensure a safe, kind, and age-appropriate environment.'
  },
  {
    icon: Shield,
    title: 'Protected interactions',
    body: 'Spiick’s AI is specifically designed for children: content is filtered, responses are controlled, and interactions are secured to prevent exposure to inappropriate material.'
  },
  {
    icon: Lock,
    title: 'Parental control',
    body: 'Parents stay in control at all times: screen time limits, feature settings, interaction tracking, and data protection — all within a simple and accessible interface.'
  }
];

export default function Safety() {
  return (
    <section className="relative w-full py-10 lg:py-14 bg-white">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10">
        <div className="mt-0 grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it) => (
            <div key={it.title} className="rounded-[28px] bg-white p-7 lg:p-9 hover:bg-white hover:shadow-[0_18px_40px_-20px_rgba(104,23,255,0.25)] hover:-translate-y-1 transition-all duration-300 border border-black/5 flex flex-col items-center text-center">
              <it.icon className="w-10 h-10 text-[#6817FF]" strokeWidth={2} />
              <h3 className="font-display mt-7 text-[30px] lg:text-[26px] font-semibold tracking-tight text-[#0c0a1a]">{it.title}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-[#555266]">{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
